import { create } from 'zustand'
import AsyncStorage from '@react-native-async-storage/async-storage'

const KIOSK_STORAGE_KEY = '@kiosk_mode'

const useKioskStore = create((set, get) => ({
    kioskModeEnabled: false,
    unlockCode: undefined,
    eventInstanceID: undefined,
    _hasHydrated: false,

    hydrate: async () => {
        try {
            const stored = await AsyncStorage.getItem(KIOSK_STORAGE_KEY)
            if (stored) {
                const parsed = JSON.parse(stored)
                set({
                    kioskModeEnabled: parsed.kioskModeEnabled || false,
                    unlockCode: parsed.unlockCode,
                    eventInstanceID: parsed.eventInstanceID,
                    _hasHydrated: true
                })
            } else {
                set({ _hasHydrated: true })
            }
        } catch (e) {
            set({ _hasHydrated: true })
        }
    },

    lockKioskMode: async (unlockCode, eventInstanceID) => {
        const newState = { kioskModeEnabled: true, unlockCode, eventInstanceID }
        set(newState)
        await AsyncStorage.setItem(KIOSK_STORAGE_KEY, JSON.stringify(newState))
    },

    unlockKioskMode: async () => {
        const newState = { kioskModeEnabled: false, unlockCode: undefined, eventInstanceID: undefined }
        set(newState)
        await AsyncStorage.removeItem(KIOSK_STORAGE_KEY)
    },

    clearKioskMode: async () => {
        set({ kioskModeEnabled: false, unlockCode: undefined, eventInstanceID: undefined })
        await AsyncStorage.removeItem(KIOSK_STORAGE_KEY)
    }
}))

export default useKioskStore